// extracted by mini-css-extract-plugin
module.exports = {"interstitialHeader":"Interstitial-InterstitialHeader-module--interstitial-header--a9Gko"};